export const getXlSizeModalStyles = (): string => {
  return `
    max-width: 1500px;
    min-width: 1024px;
  `
}
